import React from 'react';
import {Text, View} from 'react-native';

import {Code, Heading, Spacer} from '/component/base/Storybook';

import ProfileHeader from '../ProfileHeader';

import {styles} from './ProfileHeader.style';

export default () => (
  <>
    <Heading level={2}>Profile Header Text Title</Heading>
    <Spacer size={16} />
    <Text>See client profile as an example.</Text>
    <Spacer size={16} />
    <View style={styles.wrapper}>
      <ProfileHeader
        title="title"
        name="name"
        email="email"
        avatarUrl="https://reactnative.dev/img/tiny_logo.png"
        isCoach={true}
      />
    </View>

    <Spacer size={20} />
    <Code>{'title="title"'}</Code>
  </>
);
